/**
 * Created by sange on 30/09/2017.
 */
import { Injectable } from '@angular/core'
import { CanActivate } from '@angular/router'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs/Observable'
import { of } from 'rxjs/observable/of'
import { catchError, switchMap } from 'rxjs/operators'

import * as fromTeam from '../store/'
import { AppState } from '../../../store'

import { getFromStoreOrAPI } from '../../utils/helpers'

@Injectable()
export class ConversationTeamsGuard implements CanActivate {

  constructor(private store: Store<AppState>) {
  }

  canActivate(): Observable<boolean> {
    return getFromStoreOrAPI({
      store: this.store,
      action: new fromTeam.LoadConversationTeams(),
      selector: fromTeam.getConversationTeamsSelector
    }).pipe(
      switchMap(() => of(true)),
      catchError(() => of(false)))
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/team/guards/conversation-teams.guard.ts